"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.HeroBrandDefaultProps = exports.HeroBrand = void 0;
var _heroBrand = _interopRequireDefault(require("./components/hero-brand"));
exports.HeroBrand = _heroBrand["default"];
var _heroBrand2 = _interopRequireDefault(require("./components/hero-brand.props/hero-brand.defaultProps"));
exports.HeroBrandDefaultProps = _heroBrand2["default"];